import { useMemo } from 'react';
import { DisplayEntityIdType } from '@ydistri/api-sdk';
import { SYSTEM_ID_LABEL } from '../_constants';
import { isSameId } from '../../../lib/utils/utils';
import { IdentificationItem } from './Identifications';

export enum SystemIdMode {
  ONLY_WITH_CUSTOMER_ID = 'only-with-customer-id',
  DIFFERENT_ONLY = 'different-only',
  ALWAYS = 'always',
}

export interface UseIdentificationItemsParams {
  displayId?: DisplayEntityIdType;
  entityId?: number;
  entityCode?: string | null;
  entityCustomerId?: string | null;
  systemIdMode?: SystemIdMode;
}

export const useIdentificationItems = ({
  displayId,
  entityId,
  entityCode,
  entityCustomerId,
  systemIdMode = SystemIdMode.ONLY_WITH_CUSTOMER_ID,
}: UseIdentificationItemsParams): IdentificationItem[] => {
  return useMemo(() => {
    const items: IdentificationItem[] = [];
    let systemIdAdded = false;

    if (displayId === DisplayEntityIdType.CustomerId) {
      items.push({ label: 'Id', value: entityCustomerId ?? '' });

      if (
        systemIdMode === SystemIdMode.ONLY_WITH_CUSTOMER_ID &&
        entityId &&
        !isSameId(entityId, entityCustomerId)
      ) {
        items.push({ label: SYSTEM_ID_LABEL, value: entityId.toString() });
        systemIdAdded = true;
      }
    }

    if (displayId === DisplayEntityIdType.Code) {
      items.push({ label: 'Code', value: entityCode ?? '' });
    }

    if (!systemIdAdded) {
      if (
        systemIdMode === SystemIdMode.ALWAYS ||
        (systemIdMode === SystemIdMode.DIFFERENT_ONLY &&
          entityId &&
          (!isSameId(entityId, entityCustomerId) || displayId === DisplayEntityIdType.Code))
      ) {
        items.push({ label: SYSTEM_ID_LABEL, value: entityId?.toString() ?? '' });
      }
    }

    return items;
  }, [displayId, entityId, entityCode, entityCustomerId, systemIdMode]);
};
